import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { withSnackbar } from "notistack";
import {
    IconButton,
    Typography,
    AppBar,
    Dialog,
    DialogTitle,
    DialogContent,
    Paper,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    DialogActions,
    Button,
    Table,
    Menu,
    MenuItem,
    ListItemIcon,
    Tabs,
    Tab,
    Box,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText
} from "@material-ui/core";
import { Assignment, AssignmentInd, KeyboardArrowLeft, KeyboardArrowRight, MoreVert, CheckCircleOutlineRounded, HighlightOffRounded } from "@material-ui/icons";
import CustomTableRow from "../Row/CustomTableRow";
import axios from "axios";
import dayjs from "dayjs";
import TimeReportDialog from "../TimeReportDialog";

const styles = theme => ({
    root: {
        flexGrow: 1
    },
    title: {
        flexGrow: 1
    },
    userName: {
        flexGrow: 1,
        textAlign: "center"
    },
    container: {
        maxHeight: "60vh"
    }
});

export function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && <Box p={0}>{children}</Box>}
        </div>
    );
}

export function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`
    };
}

export class StandardBackToolbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportIsOpen: false,
            menuAnchorEl: null,
            value: 0,
            loginOverviewIsOpen: false,
            checkedInList: [],
            checkedOutList: []
        };
    }

    handleOpenLoginOverview = event => {
        axios.get("/api/timeregistration/GetAllEmployees").then(res => {
            const employees = res.data;

            const checkedInEmployees = employees.filter(function(el) {
                return el.isCheckedIn === true;
            });
            const checkedOutEmployees = employees.filter(function(el) {
                return el.isCheckedIn === false;
            });
            this.setState({
                loginOverviewIsOpen: true,
                checkedInList: checkedInEmployees,
                checkedOutList: checkedOutEmployees
            });
        });
    };
    handleCloseLoginOverview = event => {
        this.setState({ loginOverviewIsOpen: false, menuAnchorEl: null });
    };

    handleOpenReport = () => {
        console.log("Opening time report!");
        this.setState({ reportIsOpen: true, menuAnchorEl: null });
    };

    handleCloseReport = () => {
        console.log("Closing time report!");
        this.setState({ reportIsOpen: false });
    };

    handleOpenMenu = event => {
        this.setState({ menuAnchorEl: event.currentTarget });
    };

    handleCloseMenu = () => {
        this.setState({ menuAnchorEl: null });
    };

    handleTabChange = (event, newValue) => {
        this.setState({ value: newValue });
    };

    render = () => {
        const { classes } = this.props;

        const primaryText = {
            fontSize: "16px"
        };

        const secondaryText = {
            fontSize: "14px"
        };

        return (
            <>
                {this.props.headerText != null ? (
                    <Typography variant="h6" style={{ flexGrow: 1, textAlign: "center" }}>
                        {this.props.headerText}
                    </Typography>
                ) : (
                    <div />
                )}
                <IconButton aria-label="more" aria-controls="simple-menu" aria-haspopup="true" onClick={this.handleOpenMenu} style={{ color: "white" }}>
                    <MoreVert fontSize="large" />
                </IconButton>

                <Menu id="simple-menu" anchorEl={this.state.menuAnchorEl} keepMounted open={Boolean(this.state.menuAnchorEl)} onClose={this.handleCloseMenu}>
                    {this.props.report ? (
                        <MenuItem onClick={this.handleOpenReport}>
                            <ListItemIcon style={{ minWidth: "30px" }}>
                                <Assignment fontSize="small" />
                            </ListItemIcon>
                            <Typography variant="inherit">Open Report</Typography>
                        </MenuItem>
                    ) : null}
                    {this.props.loginOverview ? (
                        <MenuItem onClick={this.handleOpenLoginOverview}>
                            <ListItemIcon style={{ minWidth: "30px" }}>
                                <AssignmentInd fontSize="small" />
                            </ListItemIcon>
                            <Typography variant="inherit">Open Overview</Typography>
                        </MenuItem>
                    ) : null}
                </Menu>

                <Dialog
                    open={this.state.loginOverviewIsOpen}
                    maxWidth={"lg"}
                    fullWidth={true}
                    onClose={this.handleCloseLoginOverview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Login Overview"}</DialogTitle>
                    <AppBar position="static">
                        <Paper square>
                            <Tabs variant="fullWidth" indicatorColor="primary" textColor="primary" value={this.state.value} onChange={this.handleTabChange} aria-label="simple tabs">
                                <Tab label="Checked in" {...a11yProps(0)} />
                                <Tab label="Checked out" {...a11yProps(1)} />
                            </Tabs>
                        </Paper>
                    </AppBar>
                    <DialogContent style={{ height: "70vh" }}>
                        <div>
                            <TabPanel value={this.state.value} index={0}>
                                <List dense>
                                    {this.state.checkedInList.map(employee => {
                                        return (
                                            <ListItem key={employee.id}>
                                                <ListItemAvatar>
                                                    {employee.isCheckedIn ? (
                                                        <CheckCircleOutlineRounded fontSize="large" style={{ color: "#28a745" }} />
                                                    ) : (
                                                        <HighlightOffRounded fontSize="large" style={{ color: "#dc3545" }} />
                                                    )}
                                                </ListItemAvatar>

                                                <ListItemText
                                                    primary={employee.name}
                                                    primaryTypographyProps={{ style: primaryText }}
                                                    secondary={employee.nationalRegistryId != null ? employee.nationalRegistryId.slice(0, 6) : "-"}
                                                    secondaryTypographyProps={{ style: secondaryText }}
                                                />
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            </TabPanel>
                            <TabPanel value={this.state.value} index={1}>
                                <List dense>
                                    {this.state.checkedOutList.map(employee => {
                                        return (
                                            <ListItem key={employee.id}>
                                                <ListItemAvatar>
                                                    {employee.isCheckedIn ? (
                                                        <CheckCircleOutlineRounded fontSize="large" style={{ color: "#28a745" }} />
                                                    ) : (
                                                        <HighlightOffRounded fontSize="large" style={{ color: "#dc3545" }} />
                                                    )}
                                                </ListItemAvatar>

                                                <ListItemText
                                                    primary={employee.name}
                                                    primaryTypographyProps={{ style: primaryText }}
                                                    secondary={employee.nationalRegistryId != null ? employee.nationalRegistryId.slice(0, 6) : "-"}
                                                    secondaryTypographyProps={{ style: secondaryText }}
                                                />
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            </TabPanel>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseLoginOverview} color="default" autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <TimeReportDialog
                    open={this.state.reportIsOpen}
                    onClose={this.handleCloseReport}
                    employeeId={this.props.currentUser.id}
                />
            </>
        );
    };
}
export default withSnackbar(withStyles(styles)(withTranslation()(StandardBackToolbar)));
